"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowHistory = void 0;
class WorkflowHistory {
    constructor(workflow) {
        this.workflow = workflow;
        this.undoList = [];
        this.redoList = [];
    }
    add(delta) {
        console.log('add delta', delta);
        this.undoList.push(delta);
    }
    last(count = 1) {
        if (count === 1) {
            return this.undoList.length > 0
                ? this.undoList[this.undoList.length - 1]
                : undefined;
        }
        else if (count > 1) {
            return this.undoList.slice(-count);
        }
    }
    undo() { }
    redo() { }
}
exports.WorkflowHistory = WorkflowHistory;
exports.default = WorkflowHistory;
//# sourceMappingURL=workflow-history.js.map